export default __webpack_public_path__ + "static/media/addUser.abc3f79f.png";